import https from "./https"
import store from "@/store"

const excel = {
  export(handler, params) {
    const organization = store.state.general.organization;
    return https.get(`/admin/organizations/${organization.id}/export/${handler}`, { params });
  },
  import(handler, file, params = {}) {
    const organization = store.state.general.organization;

    const formData = new FormData();
    formData.append("file", file);
    Object.keys(params).forEach(key => {
      const value = params[key];
      // Convert boolean to "1" or "0" for Laravel validation
      if (typeof value === 'boolean') {
        formData.append(key, value ? '1' : '0');
      } else {
        formData.append(key, value);
      }
    })

    return https.post(`/admin/organizations/${organization.id}/import/${handler}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
}

export default excel
